












import Vue from "vue";
export default Vue.extend({
  props: {
    snackbar: {
      default: false,
      type: Boolean,
    },
    snackbarText: String,
  },
  methods: {
    snackbarClose() {
      this.$emit("snackbarClose", true);
    },
  },
});
